import { PreWraper } from '@components/shared/wraper/PreWraper'
import React from 'react'
import { SummaryProgramHeading } from '../Heading'

type Props = {
  venueType: string
  venueDetail: string
}

const VENUE_TYPE = ['online', 'offline', 'offline_and_online'] as [
  'online',
  'offline',
  'offline_and_online'
]

export const SummaryProgramVenue = ({
  venueType,
  venueDetail,
}: Props): JSX.Element => (
  <div className="flex flex-col">
    <SummaryProgramHeading heading="会場" />
    {venueType === VENUE_TYPE[1] ? (
      <div className="mt-[5.8vw] lg:mt-[2.2vw]">
        <div className="text-[4.3vw] lg:text-[1.3vw] text-[#333333]">
          {venueDetail}
        </div>
      </div>
    ) : (
      <>
        <div className="mt-[5.8vw] lg:mt-[2.2vw]">
          <div className="text-[4.3vw] lg:text-[1.3vw] text-[#333333]">
            {venueDetail}
          </div>
        </div>
        <div className="mt-[4.2vw] lg:mt-[1.6vw]">
          <div className="text-[3.7vw] lg:text-[1.1vw] leading-[7.5vw] lg:leading-[2.2vw] text-[#666666]">
            <PreWraper
              text={
                venueType === VENUE_TYPE[0]
                  ? `※zoomを使ってのオンライン開催となります。事前にインストールをお願いいたします。\n※zoomのURLについては、申し込み完了後、こちらのイベントページからアクセスができます。\n※zoomに障害が発生し利用が困難な場合は、代替開催場所をメールにてお伝えさせていただきます。`
                  : venueType === VENUE_TYPE[2]
                  ? `※対面およびオンライン（zoom等使用）での開催となります。zoomは事前にインストールをお願いいたします。\n※zoomのURLについては、申し込み完了後、こちらのイベントページからアクセスができます。\n※zoomに障害が発生し利用が困難な場合は、代替開催場所をメールにてお伝えさせていただきます。`
                  : ''
              }
            />
          </div>
        </div>
      </>
    )}
  </div>
)
